import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthModal from './AuthModal';

export default function AuthModalPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const defaultMode = pathname === '/signup' ? 'signup' : 'login';
  const [mode, setMode] = React.useState(defaultMode);

  return (
    <AuthModal
      isOpen={true}
      mode={mode}
      onModeSwitch={setMode}
      onClose={() => navigate('/')}
    />
  );
}







